import { Component, DestroyRef, effect, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  MatTableModule
} from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, firstValueFrom } from 'rxjs';
import { CreateUserPayload, User } from '@shared/interfacres/user';
import { UsersManagerStore } from '@data-access/manager/stores/users-manager.store';
import { IconInput } from '@shared/components/icon-input/icon-input';
import { MatProgressBar } from '@angular/material/progress-bar';
import { EditUserDialog } from './edit-user-dialog/edit-user-dialog';
import { mapFormToPayload } from '@shared/helpers/user-form-to-payload';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog';
import { DatePipe } from '@angular/common';
import { CustomPaginator, PAGINATOR_LABEL } from '@shared/components/custom-paginator/custom-paginator';


@Component({
  selector: 'app-users',
  imports: [
    MatTableModule,

    MatIcon,
    MatSlideToggle,

    IconInput,

    // MatPaginator,
    MatProgressBar,
    MatSort,
    MatSortHeader,
    ReactiveFormsModule,
    DatePipe,
    CustomPaginator
  ],
  providers: [{provide: PAGINATOR_LABEL, useValue: 'Users per page: '}],
  templateUrl: './users.html',
  styleUrl: './users.scss'
})
export class Users implements OnInit, OnDestroy {
  displayedColumns: string[] = ['email', 'firstName', 'lastName', 'createdAt', 'subscriptionStatus', 'isApproved', 'isRejected', 'actions'];
  // protected readonly countries = countries;

  dataSource: User[] = [];
  total = 0;
  searchValue = new FormControl('');

  // @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  selection = new SelectionModel<number>(
    true,
    []
  );

  readonly store = inject(UsersManagerStore);
  private destroyRef = inject(DestroyRef);
  readonly dialog = inject(MatDialog);

  constructor(
  ) {

    effect(() => {
      this.dataSource = this.store.items();
      this.total = this.store.total();
    });
  }

  ngOnInit(): void {

    this.searchValue.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(400),
      )
      .subscribe(input => {
        this.store.getByName(input as string);
      })
    this.store.setFilter('updated_at', 'desc');
  }

  changePage(page: {pageIndex: number; pageSize: number}) {
    this.store.setPagination(page.pageIndex + 1, page.pageSize);
  }

  sortChange(event: {active: string; direction: string}) {
    this.store.setFilter(event.active, event.direction as 'asc' | 'desc');
  }

  async openDialog(item: User) {
    const performanceTypes = await firstValueFrom(this.store.getPerformanceTypes());

    const dialogRef = this.dialog.open(EditUserDialog, {
      data: {
        user: {
          ...item,
          // performanceType: item.performanceType
        },
        performanceTypes
      },
      disableClose: true,
      width: '600px',
      maxWidth: '800px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });
    //
    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      const editUserPayload: Partial<CreateUserPayload> = {
        ...mapFormToPayload(result.userData),
      };

      this.store.update(item.id, editUserPayload);
    }
  }

  async rejectUser(userId: string, idRejected: boolean) {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        title: idRejected ? 'Reject' : 'Revert rejection' ,
        message: idRejected ? 'Are you sure you want to reject user?' : 'Are you sure you want to restore user?'
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });
    const result = await firstValueFrom(dialogRef.afterClosed());
    console.log('users.ts => rejectUser: ', userId, result);
    // const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {

      this.store.reject(userId, idRejected);
      this.selection.clear();
    }
  }

  async delete(userId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        title: 'Delete user',
        message: 'Are you sure you want to delete user?'
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });
    const result = await firstValueFrom(dialogRef.afterClosed());

    if (result) {

      this.store.delete(userId);
      this.selection.clear();
    }
  }

  approve(checked: boolean, userId: string) {
    this.store.approval(userId, checked);
  }

  ngOnDestroy() {
    this.store.clearCriteria();
  }
}
